import { InputComponentType } from "../../../utils/enums";

export const courseInformationFields = [
  {
    name: "courseName",
    label: "Course Title",
    type: "text",
    required: true,
    component: InputComponentType.TextField,
  },
  {
    name: "courseBeginDate",
    label: "Start Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "courseEndDate",
    label: "End Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "location",
    label: "Location",
    type: "text",
    component: InputComponentType.FreeTextDropdown,
  },
  {
    name: "hours",
    label: "Hours",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "category",
    label: "Category",
    type: "text",
    component: InputComponentType.FreeTextDropdown,
  },
  {
    name: "courseNumber",
    label: "Course #",
    type: "text",
    component: InputComponentType.TextField,
    isDisabled: (formValues) => !!formValues.id,
    isIdField: true,
  },
  {
    name: "instructor",
    label: "Instructor",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "tuitionDefault",
    label: "Tuition Default Cost",
    type: "text",
    component: InputComponentType.TextField,
  },
];

export const courseCertificationFields = [
  {
    name: "certification",
    label: "Certification Type",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "expireDate",
    label: "Expiration Date",
    component: InputComponentType.DatePicker,
  },
];
